import { noop } from 'lodash';

const withDefaultPrevented = (fn) => {
  const wrapper = typeof fn === 'function' ? fn : noop;

  return (event, ...extra) => {
    if (event && typeof event.preventDefault === 'function') {
      event.preventDefault();
    }
    return wrapper(event, ...extra);
  };
};

export default withDefaultPrevented;
